/* TOMAPREÇO · header: sugestões de busca, mega menu, "todos os departamentos", faixa rotativa · ÁREA A */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var desktop = window.matchMedia('(min-width: 990px)');

  /* ---------- busca com sugestões (/search/suggest.json: produtos, coleções, termos) ---------- */
  function initSearch(box) {
    var input = $('.tp-search__input', box), list = $('.tp-suggest', box);
    if (!input || !list) return;
    var timer, ctrl, active = -1, lastQ = '';
    function hide() { list.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; }
    function items() { return $$('[role="option"]', list); }
    function mark(i) {
      var it = items(); if (!it.length) return;
      active = (i + it.length) % it.length;
      it.forEach(function (el, j) { el.setAttribute('aria-selected', j === active ? 'true' : 'false'); });
      input.setAttribute('aria-activedescendant', it[active].id);
    }
    function money(c) { return window.TP ? TP.money(c) : ''; }
    function render(q, j) {
      var r = (j && j.resources && j.resources.results) || {};
      var qs = r.queries || [], cols = r.collections || [], prods = r.products || [];
      if (!qs.length && !cols.length && !prods.length) {
        list.innerHTML = '<div class="tp-suggest__group"><p class="tp-suggest__item">Nenhuma sugestão para “' + esc(q) + '”.</p></div>';
      } else {
        var n = 0, h = '';
        if (qs.length) h += '<div class="tp-suggest__group"><p class="tp-suggest__label">Buscas</p>' + qs.slice(0, 4).map(function (x) { return '<a role="option" id="tp-sg-' + (n++) + '" class="tp-suggest__item" href="' + esc(x.url) + '">' + (x.styled_text || esc(x.text)) + '</a>'; }).join('') + '</div>';
        if (cols.length) h += '<div class="tp-suggest__group"><p class="tp-suggest__label">Departamentos e categorias</p>' + cols.slice(0, 4).map(function (x) { return '<a role="option" id="tp-sg-' + (n++) + '" class="tp-suggest__item" href="' + esc(x.url) + '">' + esc(x.title) + '</a>'; }).join('') + '</div>';
        if (prods.length) h += '<div class="tp-suggest__group"><p class="tp-suggest__label">Produtos</p>' + prods.slice(0, 6).map(function (x) {
          var im = x.featured_image && x.featured_image.url ? x.featured_image.url + (x.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=88' : (x.image ? x.image + '&width=88' : '');
          var cents = Math.round(parseFloat(x.price) * 100);
          return '<a role="option" id="tp-sg-' + (n++) + '" class="tp-suggest__item" href="' + esc(x.url) + '">' + (im ? '<img src="' + esc(im) + '" alt="" width="44" height="44" loading="lazy">' : '') + '<span>' + esc(x.title) + '</span><span class="tp-suggest__price">' + (isNaN(cents) ? '' : money(cents)) + '</span></a>';
        }).join('') + '</div>';
        h += '<a class="tp-suggest__all" href="/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">Ver todos os resultados para “' + esc(q) + '”</a>';
        list.innerHTML = h;
      }
      list.hidden = false; input.setAttribute('aria-expanded', 'true'); active = -1;
    }
    function fetchSuggest(q) {
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      fetch(url, { signal: ctrl ? ctrl.signal : undefined }).then(function (r) { return r.json(); }).then(function (j) { if (q === lastQ) render(q, j); }).catch(function () {});
    }
    input.addEventListener('input', function () {
      var q = input.value.trim(); lastQ = q; clearTimeout(timer);
      if (q.length < 2) { hide(); return; }
      timer = setTimeout(function () { fetchSuggest(q); }, 180);
    });
    input.addEventListener('keydown', function (e) {
      if (list.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); mark(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); mark(active - 1); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); items()[active].click(); }
      else if (e.key === 'Escape') hide();
    });
    input.addEventListener('focus', function () { if (input.value.trim().length >= 2 && list.innerHTML) { list.hidden = false; input.setAttribute('aria-expanded', 'true'); } });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) hide(); });
  }

  /* ---------- mega menu por departamento (hover com intenção + teclado) ---------- */
  function initMega(nav) {
    var items = $$('[data-tp-mega]', nav), openT, closeT;
    function setOpen(li, on) {
      li.classList.toggle('is-open', on);
      var t = li.querySelector('.tp-nav__link'); if (t) t.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    function closeAll(except) { items.forEach(function (li) { if (li !== except) setOpen(li, false); }); }
    items.forEach(function (li) {
      li.addEventListener('mouseenter', function () {
        if (!desktop.matches) return;
        clearTimeout(closeT); clearTimeout(openT);
        openT = setTimeout(function () { closeAll(li); closeAll_all(); setOpen(li, true); }, 120);
      });
      li.addEventListener('mouseleave', function () { clearTimeout(openT); closeT = setTimeout(function () { setOpen(li, false); }, 160); });
      var trigger = li.querySelector('.tp-nav__link');
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || (e.key === ' ' && trigger.tagName === 'BUTTON')) { e.preventDefault(); closeAll(li); setOpen(li, true); var f = li.querySelector('.tp-mega a'); if (f) f.focus(); }
        if (e.key === 'Escape') { setOpen(li, false); trigger.focus(); }
      });
      if (trigger.tagName === 'BUTTON') trigger.addEventListener('click', function () { var on = !li.classList.contains('is-open'); closeAll(li); setOpen(li, on); });
      li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) setOpen(li, false); });
      li.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setOpen(li, false); trigger.focus(); } });
    });

    // "Todos os departamentos"
    var btn = $('[data-tp-allmenu]', nav), panel = $('[data-tp-allpanel]', nav);
    function closeAll_all() { if (panel && panel.classList.contains('is-open')) { panel.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); } }
    if (!btn || !panel) return;
    var tabs = $$('[data-tp-alltab]', panel);
    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab; t.setAttribute('aria-selected', on ? 'true' : 'false');
        var p = document.getElementById(t.getAttribute('aria-controls')); if (p) p.hidden = !on;
      });
    }
    if (tabs.length) select(tabs[0]);
    tabs.forEach(function (t) {
      t.addEventListener('mouseenter', function () { select(t); });
      t.addEventListener('focus', function () { select(t); });
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(t);
        if (e.key === 'ArrowDown') { e.preventDefault(); tabs[(i + 1) % tabs.length].focus(); }
        if (e.key === 'ArrowUp') { e.preventDefault(); tabs[(i - 1 + tabs.length) % tabs.length].focus(); }
      });
    });
    function toggle(on) {
      panel.classList.toggle('is-open', on); btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) closeAll(null);
    }
    btn.addEventListener('click', function () { toggle(!panel.classList.contains('is-open')); });
    var allT;
    btn.addEventListener('mouseenter', function () { if (desktop.matches) { clearTimeout(allT); allT = setTimeout(function () { toggle(true); }, 150); } });
    btn.addEventListener('mouseleave', function () { clearTimeout(allT); allT = setTimeout(function () { if (!panel.matches(':hover')) toggle(false); }, 200); });
    panel.addEventListener('mouseenter', function () { clearTimeout(allT); });
    panel.addEventListener('mouseleave', function () { allT = setTimeout(function () { toggle(false); }, 200); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('is-open')) { toggle(false); btn.focus(); } });
    document.addEventListener('click', function (e) { if (!nav.contains(e.target)) { toggle(false); closeAll(null); } });
  }

  /* ---------- faixa superior rotativa (mobile) ---------- */
  function initRotate(ul) {
    var its = $$('.tp-topbar__item', ul); if (its.length < 2) return;
    var i = 0, reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    setInterval(function () {
      if (desktop.matches || window.innerWidth >= 750) return;
      its[i].classList.remove('is-on'); i = (i + 1) % its.length; its[i].classList.add('is-on');
    }, 4000);
  }

  /* ---------- sombra do header ao rolar + altura para sticky interno ---------- */
  function initSticky(h) {
    var set = function () { document.documentElement.style.setProperty(desktop.matches ? '--tp-header-h' : '--tp-header-h-m', h.offsetHeight + 'px'); };
    set(); window.addEventListener('resize', set, { passive: true });
    var on = false;
    window.addEventListener('scroll', function () { var s = window.scrollY > 8; if (s !== on) { on = s; h.classList.toggle('is-stuck', s); } }, { passive: true });
  }

  function init() {
    $$('[data-tp-search]').forEach(initSearch);
    $$('.tp-nav').forEach(initMega);
    $$('[data-tp-rotate]').forEach(initRotate);
    var h = $('[data-tp-header]'); if (h) initSticky(h);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
